import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { PropertyEquipment } from '@workspace/data-types';
import { ButtonCardComponent } from '@workspace/ng-aura';
import { PropertyEquipmentsForm } from '../../../types/property-form.types';

import { PropertyEquipmentItem } from './property-equipment.constants';

@Component({
  selector: 'etxe-property-equipments-list',
  imports: [CommonModule, ReactiveFormsModule, MatIconModule, ButtonCardComponent],
  templateUrl: './equipments-list.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PropertyEquipmentsListComponent {
  items = input.required<PropertyEquipmentItem[]>();
  form = input.required<FormGroup<PropertyEquipmentsForm>>();

  onToggle(equipment: PropertyEquipment) {
    const control = this.form().controls.items;
    const currentItems = control.value || [];

    if (currentItems.includes(equipment)) {
      control.setValue(currentItems.filter((item) => item !== equipment));
    } else {
      control.setValue([...currentItems, equipment]);
    }
  }

  isActive(equipment: PropertyEquipment): boolean {
    return !!this.form().controls.items?.value?.includes(equipment);
  }
}
